import posthog from "posthog-js";

// // // //

/**
 * track
 * Analytics function to track events in the dashboard via tRPC
 */
export async function track(
    eventName: string,
    eventProperties?: Record<string, any>,
) {
    const properties = eventProperties || {};

    const trackProps = {
        name: eventName,
        properties: {
            ...properties,
            // Capture browser pathname (i.e. "/downloads")
            pathname: window.location.pathname,
        },
    };

    // Track event in Posthog
    posthog.capture(eventName, {
        ...properties,
        // Capture browser pathname (i.e. "/downloads")
        pathname: window.location.pathname,
    });
}
